import type { TreeData } from '../../components/tree/useTreeApi';

// Rewrites ids to depth:rawId compound format used by the company browse-tree
// picker (getSelectionListItem parses by splitting on _ then :).
export const applyDepthCompoundIds = (
  treeData: readonly TreeData[],
  parentCompound?: string,
  recursionDepth = 0
): TreeData[] =>
  treeData.map((node) => {
    const rawId = String(node.id);
    const depthPrefix = node.depth ?? recursionDepth;
    const segment = `${depthPrefix}:${rawId}`;
    const compoundId = parentCompound
      ? `${parentCompound}_${segment}`
      : segment;

    return {
      ...node,
      id: compoundId,
      ...(node.children
        ? {
            children: applyDepthCompoundIds(
              node.children,
              compoundId,
              recursionDepth + 1
            ),
          }
        : {}),
    };
  });
